import { request } from '@/shared/api/request'

export const getXml = (body) => request({ url: `admin/get/xml`, method: 'POST', data: body })